import { NavLink } from "react-router-dom";
import { DATA_TABLE_TYPES } from "./DataTable";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ErrorStatus, SuccessStatus } from "./Components";
import moment from "jalali-moment";
import { useDataTable } from "../../hooks/useDataTable";

export const CheckStatus = ({value}) => {
    return value?<SuccessStatus icon={faCheckCircle} />:<ErrorStatus icon={faTimesCircle} />;
}
export const ColumnData = ({row, column, index}) => {
    const {currentPage, pageSize, filterConfig} = useDataTable();
    const ColumnValue = ({children}) => {
        if(column?.to && typeof column?.to === "function"){
            return (
                <NavLink to={column.to(row)}>{children}</NavLink>
            )
        }
        return children;
    }
    const ColumnValueByType = ({value}) => {
        if(column.key === "id" && column.label === "#"){
            return ((index + 1) + ((currentPage - 1) * pageSize));
        }else if(column?.type === DATA_TABLE_TYPES.YES_OR_NO_ICON){
            return <CheckStatus value={value} />
        }else if(column?.type === DATA_TABLE_TYPES.DATE_TIME){
            const formattedDate = moment(value).format("D MMM YYYY HH:mm");
            return formattedDate
        }else if(column?.type === DATA_TABLE_TYPES.DATE){
            const formattedDate = moment(value).format("D MMM YYYY");
            return formattedDate
        }else if(column?.type === DATA_TABLE_TYPES.TIME){
            const formattedDate = moment(value).format("HH:mm");
            return formattedDate
        }else if(column?.type === DATA_TABLE_TYPES.REPORT_DATE){
            if(filterConfig?.[column.key]){
                if(filterConfig?.[column.key].type === "year"){
                    value = value + "-01";
                    const formattedDate = moment(value).format("MMMM YYYY");
                    return formattedDate;
                }else if(filterConfig?.[column.key].type === "month" || filterConfig?.[column.key].type === "range"){
                    const formattedDate = moment(value).format("D MMM YYYY");
                    return formattedDate;
                }
            }
        }
        return value??"-";
    }
    return (
        <ColumnValue>
            {column.render?(
                column.render(row)
            ):(
                <ColumnValueByType value={row?.[column.key]} />
            )}
        </ColumnValue>
    )
}